import script from "./Activity_Goodkid20260827.vue?vue&type=script&setup=true&lang=js"
export * from "./Activity_Goodkid20260827.vue?vue&type=script&setup=true&lang=js"

import "./Activity_Goodkid20260827.vue?vue&type=style&index=0&id=0d7aa8fd&lang=less&scoped=true"
import "./Activity_Goodkid20260827.vue?vue&type=style&index=1&id=0d7aa8fd&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d7aa8fd"]])

export default __exports__